module.exports = __webpack_public_path__ + "img/134.7.24768514.png";